<div class="card form-card" [ngClass]="to['class']" [checkPermissions]="{ roles: props.permissions?.roles, permissions: props.permissions?.permissions }">
  @if (!props.isCollapsible && props.label) {
    <h3 class="card-header" [ngClass]="to['showErrors'] && cardFormControl?.invalid && form.touched ? 'text-danger' : ''">
      {{ props.label  }}
      @if (to['showErrors'] && cardFormControl?.invalid && form.touched) {
        <span><small>(<ng-container i18n="@@common.required">Required</ng-container>)</small></span>
      }
      @if (props.additionalText) {
        <span>{{ props.additionalText }}</span>
      }
    </h3>
  }

  @if (to['isCollapsible']) {
    <div class="card-header pointer" (click)="isCollapsed = !isCollapsed" [ngClass]="isCollapsed ? 'pb-3' : ''">
      <div class="row">
        <div class="col" [ngClass]="to['showErrors'] && cardFormControl?.invalid && form.touched ? 'text-danger' : ''">
          {{ props.label }}
          @if (to['showErrors'] && cardFormControl?.invalid && form.touched) {
            <span><small>(<ng-container i18n="@@common.required">Required</ng-container>)</small></span>
          }
        </div>
        <div class="col-auto text-end">
          @if (isCollapsed) {
            <fa-icon [icon]="['fas', 'arrow-alt-circle-down']"
              [fixedWidth]="true"
              >
            </fa-icon>
          }
          @if (!isCollapsed) {
            <fa-icon [icon]="['fas', 'arrow-alt-circle-up']"
              [fixedWidth]="true"
              >
            </fa-icon>
          }
        </div>
      </div>
    </div>
  }
  <div class="card-body" [collapse]="isCollapsed">
    @if (props.description) {
      <div>{{ props.description }}</div>
    }
    <ng-container #fieldComponent></ng-container>
  </div>
  @if (to['saveButton']) {
    <div class="card-footer">
      <div class="row">
        <div class="col">
          <button type="submit" class="btn btn-xs btn-success" i18n="@@common.save">
          :Save
        </button>
        </div>
      </div>
    </div>
  }
</div>
